import styled from 'styled-components';

export const PreferenceCheckboxRow = styled.div`
  display: flex;
  column-gap: 12px;
`;
